import React from 'react';
import * as cls from './header.module.css';
import { Link, useLocation } from 'react-router-dom';
import { Nav } from '../nav';
import { IMG_PATH, ROUTES_PATHS } from '../../../constants';
import { Button } from '../../components/button';
import { ButtonBuyNow } from '../../components/button-buy-now';

const PATHS_TO_SHOW_DEMO = [
  ROUTES_PATHS.APIS_AND_INTEGRATIONS,
  ROUTES_PATHS.ENERGY_INTELLIGENCE,
  ROUTES_PATHS.OFFER_TO_UTILITIES,
];

export const Header = () => {
  const location = useLocation();

  return (
    <header className={cls.header}>
      <div className={cls.wrapper}>
        <Link to={ROUTES_PATHS.HOME}>
          <img
            alt="voltaware energy monitor"
            className={cls.logo}
            src={`${IMG_PATH}/voltaware-energy-monitor.svg`}
          />
        </Link>

        {PATHS_TO_SHOW_DEMO.includes(location.pathname) ? (
          <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
            <Button size="sm">Get Demo</Button>
          </Link>
        ) : (
          <ButtonBuyNow size="sm" />
        )}

        <Nav />
      </div>
    </header>
  );
};
